import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { GlobalFile } from 'src/app/models/GlobalFile';

import { GlobalFilesState } from '../../global-files/global-files.state';

@Component({
    selector: 'app-pill-global-file',
    templateUrl: './pill-global-file.component.html',
    styleUrls: ['./pill-global-file.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class PillGlobalFileComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();

    @Select(GlobalFilesState.GetGlobalFilesByObjectUuid)
    getGlobalFilesByObject$: Observable<(objectUuid: string) => GlobalFile[]>;

    @Input() file: GlobalFile;
    @Input() fileUuid: string;
    @Input() objectUuid: string;

    globalFilesOfObject: GlobalFile[];

    constructor() {}

    ngOnInit(): void {
        if (this.fileUuid && this.objectUuid) {
            this.subscriptions.add(
                this.getGlobalFilesByObject$.subscribe((globalFilesByObject) => {
                    const files = globalFilesByObject(this.objectUuid);
                    this.globalFilesOfObject = files ? files : [];
                }),
            );
            this.file = this.globalFilesOfObject.filter((file) => file.uuid == this.fileUuid)[0];
        }
    }
    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
